import { GEO_STATUS_QUERY_KEY } from "@/constants/queryKeys";
import { queryClient } from "@/lib/queryClient";
import { GeoStatus } from "@/types";

// A refused visitor's billed proof buys nothing, unless a fingerprint whitelist could let them in.
// Not known yet counts as not refused: the server still judges the sign-in.
export const isDeviceProofWasted = (): boolean => {
  const geo = queryClient.getQueryData<GeoStatus>(GEO_STATUS_QUERY_KEY);
  return Boolean(geo && (geo.restricted || geo.blocked) && !geo.proofCanPass);
};
